const r = (e) => {
  const p = /[\\^$.*+?()[\]{}|]/g, c = RegExp(p.source);
  return e && c.test(e) ? e.replace(p, "\\$&") : e;
};
export {
  r as escapeRegExp
};
